export default __webpack_public_path__ + "static/floral_topaz-1241bbed282b366d651f35ab25de32d0.png";